import type { FileUploadValidationRules } from './file-upload-rules';
import { resolveUploadContentType } from './resolve-upload-content-type';

/** Verifica formato e tamanho; retorna mensagem ou `null` se válido. */
export function validateUploadFile(
  file: File,
  rules: FileUploadValidationRules
): string | null {
  if (!fileMatchesAcceptedTypes(file, rules)) {
    return rules.invalidTypeMessage;
  }
  if (file.size > rules.maxBytesPerFile) {
    return rules.tooLargeMessage;
  }
  return null;
}

export function fileMatchesAcceptedTypes(
  file: File,
  rules: FileUploadValidationRules
): boolean {
  const resolved = resolveUploadContentType(file);
  if (rules.allowPdfExtensionFallback === true) {
    const lower = file.name.toLowerCase();
    if (
      file.type === 'application/pdf' ||
      resolved === 'application/pdf' ||
      lower.endsWith('.pdf')
    ) {
      return true;
    }
  }
  return (
    rules.allowedMimeTypes.includes(resolved) ||
    rules.allowedMimeTypes.includes(file.type)
  );
}

export interface RejectedUploadFile {
  readonly file: File;
  readonly message: string;
}

export function partitionValidatedFiles(
  files: readonly File[],
  rules: FileUploadValidationRules | null
): { accepted: File[]; rejected: RejectedUploadFile[] } {
  if (!rules) {
    return { accepted: [...files], rejected: [] };
  }
  const accepted: File[] = [];
  const rejected: RejectedUploadFile[] = [];
  for (const file of files) {
    const msg = validateUploadFile(file, rules);
    if (msg) {
      rejected.push({ file, message: msg });
    } else {
      accepted.push(file);
    }
  }
  return { accepted, rejected };
}
